/* Cart drawer. Opens on add (theme.js dispatches cart:added), on the header
   cart icon, and refreshes itself through the Section Rendering API so the
   Liquid in sections/cart-drawer.liquid stays the only template. */
(function () {
  'use strict';
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !window.fetch) return;
  var SECTION = 'cart-drawer';
  var lastFocus = null;

  function refresh() {
    return fetch('/?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var tmp = document.createElement('div');
        tmp.innerHTML = json[SECTION] || '';
        var fresh = tmp.querySelector('#CartDrawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        var count = drawer.querySelector('[data-drawer-count]');
        if (count) {
          var n = parseInt(count.getAttribute('value'), 10) || 0;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = n; el.hidden = n === 0;
          });
        }
      });
  }

  function open(added) {
    lastFocus = document.activeElement;
    var msg = drawer.querySelector('[data-cart-added]');
    if (msg) msg.hidden = !added;
    drawer.hidden = false;
    document.documentElement.classList.add('cart-drawer-open');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = drawer.querySelector('.cart-drawer__panel');
      if (panel) panel.focus();
    });
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refresh);
  }

  document.addEventListener('cart:added', function () { refresh().then(function () { open(true); }); });

  document.querySelectorAll('a.header__cart').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      refresh().then(function () { open(false); });
    });
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); change(rm.getAttribute('data-cart-remove'), 0); }
  });

  drawer.addEventListener('change', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) change(q.getAttribute('data-cart-qty'), Math.max(0, parseInt(q.value, 10) || 0));
  });

  drawer.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { var msg = drawer.querySelector('[data-cart-added]'); if (msg) msg.hidden = false; })
      .catch(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
})();
